// extracted by mini-css-extract-plugin
export default {"landingPageWrapper":"LandingPage_landingPageWrapper__87LYT"};